import React, { useCallback, useEffect } from "react";
const classNames = require("classnames");

import useComponentVisible from "../../hooks/useComponentVisible";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Popover } from "../../Components/Overlays";
import { PopoverContent } from "../../Components/Overlays/Popover/Popover";

const ChannelText = styled.p`
  display: inline-block;

  span {
    margin-right: 4px;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #aab2b6;
    text-decoration: underline;
    font-size: inherit;
    transition: color 0.2s;
    &:hover {
      color: #444;
    }
  }
`;

function CampaignCreateChannelView({
  onShowPreview,
  minCampaignDuration,
  addBudget,
  budgetDifference,
  name,
  fullname,
  description,
  isEditing,
  canRemove,
  onItemRemoved,
  isActive,
  channelRequiresLongerDuration,
  onItemAdded,
  onChangeDuration
}) {
  const {
    ref: modalRef,
    isComponentVisible: isModalShowing,
    setIsComponentVisible: setIsModalShowing
  } = useComponentVisible(false, () => {});

  const { t } = useTranslation();

  useEffect(() => {
    if (channelRequiresLongerDuration) {
      setIsModalShowing(true);
    }
  }, [channelRequiresLongerDuration, setIsModalShowing]);

  const togglePreview = useCallback(
    (e) => {
      e.preventDefault();
      onShowPreview();
    },
    [onShowPreview]
  );

  const renderCampaignDurationTooShortModal = () => {
    return (
      <div className="add_warning" ref={modalRef}>
        <span className="text">{t("Campaign duration is not sufficient")}</span>
        <br />
        <div className="action" onClick={onChangeDuration}>
          {t("changeCampaignDuration", { minCampaignDuration })}
        </div>
      </div>
    );
  };

  const renderBudgetMissingModal = () => {
    return (
      <div className="add_warning" ref={modalRef}>
        <span className="text"> {t("Budget is not enough")}</span>
        <br />
        <div className="action" onClick={addBudget}>
          {" "}
          {t("Increase budget by €{{budgetDifference}}", {
            budgetDifference: Math.abs(budgetDifference)
          })}
        </div>
      </div>
    );
  };

  const renderModal = () => {
    if (budgetDifference < 0 && isModalShowing && !channelRequiresLongerDuration) {
      return renderBudgetMissingModal();
    }

    if (channelRequiresLongerDuration && isModalShowing) {
      return renderCampaignDurationTooShortModal();
    }

    return <></>;
  };

  const addItem = () => {
    onItemAdded();
    setIsModalShowing(true);
  };

  const activeStyle = classNames({
    channel_wrapper: true,
    "fade-in": true
  });

  return (
    <div className={activeStyle}>
      <div className="channel_logo">
        <img src={`/images/${name.toLowerCase()}.png`}></img>
      </div>

      <div className="description">
        <h4>{fullname || name}</h4>
        <ChannelText>
          <span>{description}</span>
          <button id={`${fullname}_example`} onClick={togglePreview}>
            {t("Show example")}
          </button>
        </ChannelText>
      </div>

      {isEditing && (
        <div className="remove">
          {canRemove && (
            <div className="remove_warning">
              {t("At least one channel is required in the package")}
            </div>
          )}
          <h4 onClick={onItemRemoved}>{t("remove")}</h4>
        </div>
      )}

      {isActive && (
        <div className="remove add">
          <Popover trigger={<h4 onClick={addItem}>+ {t("add")}</h4>}>
            <PopoverContent>{renderModal()}</PopoverContent>
          </Popover>
        </div>
      )}
    </div>
  );
}

export default CampaignCreateChannelView;
